import React from 'react';
import { connect } from 'react-redux';
import {
    Card, CardBlock, CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import {Link} from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";
import swal from 'sweetalert2';

import IconPrint from 'react-icons/lib/fa/print';
import IconOpen from 'react-icons/lib/fa/folder-open-o';
import FAplus from 'react-icons/lib/fa/plus';
import IconCheck from 'react-icons/lib/md/check';
import * as actions from '../../actions/ticket';

import {API_URL} from '../../actions/_request';

// styling
import './style.css';

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };



class TicketTable extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
        };

        
    }

    confirmacion(evt,id,ticket){
      let self =this;
              swal({
        title: 'Estas seguro?',
        text: "se Confirmara el ticket: "+ticket,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
         cancelButtonText: 'Cancelar!'
      }).then((result) => {
        if (result.value) {
            
        

          let datos={
            id:id,
            insidencia:2
          };
           this.props.pagar_credito(datos, (response) => {   

             
         this.props.get_tickets_insidencias(this.props.auth.user.departamento);
          swal("Bien hecho!", "El ticket fue Confirmado con éxito!", "success");       
      });



    
        }
      })
    }

    componentDidMount() {

        let self = this;
        this.props.get_tickets_insidencias(this.props.auth.user.departamento);
        
    }

    

    render() {

        return(
            <div className="view">

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Tickets</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                            
                            <ReactTable
                             getTrProps={(state, rowInfo, column) => {
                                 
                                  if(rowInfo === undefined){
                                         
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.confirmacion(evt, rowInfo.original.id, rowInfo.original.clave)
                                        } 
                                  
                                    }
                              }}
                              
                              data      = {this.props.ticket.insidencias}
                              className = "-striped -highlight"
                              columns   = {[
                                {Header: 'Fecha', accessor: 'created_at',maxWidth:100},
                                {Header: 'Tecnico', accessor: 'creador',maxWidth:150},
                                {Header: 'No.', accessor: 'clave',maxWidth:150},
                                {Header: 'Cliente', accessor: 'cliente'},
                                {
                                    Header: 'Pagado',
                                    accessor: 'pagado',
                                     maxWidth:80,
                                    style: {paddingLeft: '5px', fontSize:'10px' },
                                    Cell: row => (
                                      <span>
                                          <span style={{
                                              color: row.value === 'SI' ? '#2962ff' : '#ff1f1f',
                                              transition: 'all .3s ease'
                                          }}>
                                          &#x25cf;
                                          </span>&nbsp;{row.value}
                                      </span>
                                      )
                                },

                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                     maxWidth:80,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                               <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.confirmacion(evt, row.original.id, row.original.clave)}>
                                                    <IconCheck />
                                                </Button>{' '}                                               
                                            </div>
                                        )
                                    }
                                }
                              ]}
                              filterable 
                              defaultPageSize={50} 
                              defaultFilterMethod={filterCaseInsensitive}
                              
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <div className='row'>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Tecnicos:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Creo Ticket:</dt>
                                                <dd className="col-sm-9">{row.original.creador}</dd>

                                                 <dt className="col-sm-3 text-truncate">Tecnico Asignado</dt>
                                                <dd className="col-sm-9">{row.original.asignado}</dd>

                                                <dt className="col-sm-3 text-truncate">Cobro:</dt>
                                                <dd className="col-sm-9">{row.original.cobro}</dd>                       

                                            </dl>
                                            </div>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Cliente:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Razon Social:</dt>
                                                <dd className="col-sm-9">{row.original.empresa}</dd>

                                                 <dt className="col-sm-3 text-truncate">Telefono</dt>
                                                <dd className="col-sm-9">{row.original.telefono}</dd>

                                                <dt className="col-sm-3 text-truncate">Contacto:</dt>
                                                <dd className="col-sm-9">{row.original.contacto}</dd>                       

                                            </dl>
                                            </div>
                                              
                                            </div>




                                             <h1 className="h4 text-uppercase">Motivo:</h1>
                                                  <dl className="row">  
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.motivo_insidencia}}></dd>
                                                  </dl>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                            />
                        </CardBlock>
                    </Card>
                </div>

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        ticket: state.ticket,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(TicketTable)





// WEBPACK FOOTER //
// ./src/views/insidencias/table.js